import axios from 'axios'
import qs from 'qs'
import { captureException, setTag } from '@sentry/vue'
import Cookies from 'js-cookie'
import { isUnauthenticatedAPI } from './utils'
import { APP_TYPES } from './constants'
import invoiceService from '@/services/invoice'

let mutexFlag = false

const token = () => Cookies.get('default_auth_token')

const notContainsUrl = (error) =>
  error &&
  error.config &&
  error.config.url &&
  (error.config.url.includes('access/sessions') ||
    error.config.url.includes('accounts/sign-out') ||
    error.config.url.includes('access/geo'))

// create an axios instance
const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_DRIP_API_HOST}/v1`,
  timeout: 120000,
  paramsSerializer: (params) => {
    return qs.stringify(params, {
      encode: false,
      arrayFormat: 'brackets'
    })
  }
})

axiosInstance.interceptors.request.use(
  (config) => {
    // ignore api which follow the below url pattern
    if (!isUnauthenticatedAPI(config.url) && token()) {
      // default code
      config.headers.Authorization = `Bearer ${token()}`
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async function (error) {
    const originalRequest = error.config

    const check401Error =
      error &&
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !mutexFlag &&
      !notContainsUrl(error)

    // Check for specific error status code indicating expired token or unauthorized access (e.g., 401)
    if (check401Error) {
      mutexFlag = true
      // Mark request as retried to avoid infinite loops
      originalRequest._retry = true // Mark request as retried to avoid infinite loops
      try {
        const responseCode = await invoiceService.validateToken() // Call validate token function
        if (responseCode) {
          window.location.href = '/'
        } else {
          window.location.href = `${process.env.VUE_APP_DRIP_PORTAL_HOST}/logout?app=${APP_TYPES.PSCF}&callback=${window.location.pathname}`
        }
        return Promise.reject(error)
      } catch (error) {
        // Handle token validation error
        console.error('Error validating token: ', error)
        // Redirect to logout page
        window.location.href = `${process.env.VUE_APP_DRIP_PORTAL_HOST}/logout?app=${APP_TYPES.PSCF}&callback=${window.location.pathname}`
        return Promise.reject(error)
      } finally {
        mutexFlag = false
      }
    }

    if (axios.isCancel(error)) {
      // Handle request cancellation
      console.log('Request canceled', error && error.message)
    } else {
      setTag('errorAPIurl', error?.response?.config?.url || '/notfound/')
      setTag('errorCode', error?.response?.status || 'N/A')
      setTag('mfSessionId', window?.mouseflow?.getSessionId() || 'N/A')
      setTag('business_id', Cookies.get('accountId') || 'N/A')

      captureException(error)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
